import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ArrowRightIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import styles from "./HistoryDetailsCells.module.scss";

export const HistoryDetailsExpandCell = memo(() => (
    <ViewTableCell className={styles.expandCell}>
        <Button
            variant="primary"
            size="md"
            iconOnly
            className={styles.expandButton}
            aria-label="View details"
            aria-hidden="true"
            tabIndex={-1}
        >
            <ArrowRightIcon />
        </Button>
    </ViewTableCell>
));

HistoryDetailsExpandCell.displayName = "HistoryDetailsExpandCell";
